<template>
  <el-dialog
    title="添加分类"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      size="small"
    >
      <el-form-item
        prop="category_name"
        label="分类名称"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.category_name"></el-input>
      </el-form-item>
      <el-form-item
              prop="category_sort"
              label="排序"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.category_sort"></el-input>1以上整数越小越靠前
      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
export default {
  name: "goodstypeEditForm",
  props: {
      oneclass: Object,
    value: Boolean
  },
  data() {
    return {
        formEdit: true,
      loading: false,
      dialogVisible: false,
      form: {
          category_name: "",
          category_sort: ""
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
        if (this.oneclass.id) {
            let form = {};
            form.category_name = this.oneclass.category_name;
            form.category_sort = this.oneclass.category_sort;
            this.form = form;
            this.formEdit = true;
        }else{
            this.form = {};
            this.formEdit = true;
        }

    },
    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {
            if (this.oneclass.id) {
                this.loading = true;
                agentService.saveGoodsType({ ...this.form,id:this.oneclass.id})
                    .then(data => {
                        this.loading = false;
                        this.dialogVisible = false;
                        this.$emit("submit");
                    });
            }else{


                            this.loading = true;
                            agentService.saveGoodsType({ ...this.form,agentid:util.cookies.get('agentid')})
                                .then(data => {
                                    this.loading = false;
                                    this.dialogVisible = false;
                                    this.$emit("submit");
                                });

            }

        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

